module.exports = __webpack_public_path__ + "static/media/400385_02.e3437fbc.png";